/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class MessageModule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            messages: []
        };

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {},
            keys = props.keys,
            nextMessages = [],
            i = 0,
            j = 0;

        if (props.app && props.app.messages !== undefined) {
            for (i = 0; i < props.app.messages.length; ++i) {
                for (j = 0; j < keys.length; ++j) {
                    if (props.app.messages[i].type.match(keys[j])) {
                        nextMessages.push(props.app.messages[i]);
                    }
                }
            }
        }

        if (nextMessages.length) {
            nextState.messages = nextMessages;
        }

        return (Object.keys(nextState).length) ? nextState : null;
    }

    render() {
        return this.props.render(this.state);
    }

}

MessageModule.displayName = "MessageModule";

export default MessageModule;
